import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FiDataFieldViewBase } from '../data-field-view-base';

@Component({
    selector: 'data-field-view-description',
    templateUrl: './description.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class FiDataFieldViewDescriptionComponent extends FiDataFieldViewBase {
    get isNotEmpty() {
        return !!this.dataFieldObject.Description;
    }
}
